import { Component, ReactNode, useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { EnquiryProvider } from "./context/EnquiryContext";
import { initLenis } from "./lib/scroll";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { TuftingSection } from "./components/TuftingSection";
import { Gallery } from "./components/Gallery";
import { HowItWorks } from "./components/HowItWorks";
import { Spaces } from "./components/Spaces";
import { EnquiryForm } from "./components/EnquiryForm";
import { Faq } from "./components/Faq";
import { Footer } from "./components/Footer";
import { FloatingActions } from "./components/FloatingActions";
import { YarnDivider } from "./components/YarnDivider";
import { ReferencePage } from "./pages/ReferencePage";

class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-ivory px-6 text-center">
          <div>
            <p className="font-serif text-2xl text-forest">Something unravelled.</p>
            <p className="mt-2 text-charcoal/70">Please refresh the page — the yarn will fall back into place.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function RouteEffects() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Shell() {
  useEffect(() => {
    initLenis();
  }, []);
  return (
    <Routes>
      <Route
        path="/"
        element={
          <div className="min-h-screen bg-ivory">
            <Header />
            <main>
              <Hero />
              <Marquee />
              <TuftingSection />
              <YarnDivider />
              <Gallery />
              <YarnDivider />
              <HowItWorks />
              <YarnDivider />
              <Spaces />
              <YarnDivider />
              <EnquiryForm />
              <YarnDivider />
              <Faq />
            </main>
            <Footer />
            <FloatingActions />
          </div>
        }
      />
      <Route path="/r/:token" element={<ReferencePage />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <EnquiryProvider>
        <BrowserRouter>
          <RouteEffects />
          <Shell />
          <Toaster position="bottom-center" richColors />
        </BrowserRouter>
      </EnquiryProvider>
    </ErrorBoundary>
  );
}
